import { render, staticRenderFns } from "./LabelSwitch.vue?vue&type=template&id=72d6e702&scoped=true&"
import script from "./LabelSwitch.vue?vue&type=script&lang=js&"
export * from "./LabelSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LabelSwitch.vue?vue&type=style&index=0&id=72d6e702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6e702",
  null
  
)

export default component.exports